<template>
  <PageLayout>
    <v-row>
      <v-col :sm="12">
        <div class="d-flex align-center pb-4">
          <router-link to="/tutorials" class="pt-1">
            <img :src="require('@/assets/ico-arrow-left.svg')" alt="" />
          </router-link>
          <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pl-4">
            Tutoriál Detail - {{ tutorialId }}
          </h2>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col :sm="12">
        <v-img
          class="tutorialDetail__img align-center justify-center mb-5"
          height="575px"
          src="https://picsum.photos/1000/575"
        >
          <div class="text-center">
            <img :src="require('@/assets/ico-play.svg')" alt="" />
          </div>
        </v-img>
      </v-col>
    </v-row>

    <v-row row wrap justify="center" class="pb-8">
      <v-col :lg="9">
        <div class="body-2 navy--text text--darken-1">
          <p>
            I'm baby drinking vinegar chillwave raw denim hammock venmo.
            Fingerstache VHS gentrify fanny pack succulents vice franzen. Food
            truck venmo literally tacos hashtag, jean shorts adaptogen tattooed.
            Vice portland disrupt humblebrag mixtape lumbersexual venmo salvia
            actually tattooed mumblecore. PBR&B pitchfork activated charcoal
            vegan hammock, portland shoreditch chia next level VHS ramps DIY
            chicharrones meditation food truck.
          </p>
          <h4>Twee wolf quinoa kinfolk</h4>
          <p>
            Farm-to-table bicycle rights raw denim, tousled kogi sustainable
            mumblecore salvia semiotics. Viral vexillologist direct trade meh
            readymade craft beer edison bulb dreamcatcher jean shorts drinking
            vinegar keytar mumblecore. Yr ramps mustache stumptown fam aesthetic
            chillwave. Tumeric unicorn cronut, knausgaard portland mlkshk cred
            occupy butcher air plant williamsburg stumptown chicharrones.
            Helvetica echo park lyft YOLO, blue bottle hella ethical PBR&B.
            Kombucha prism subway tile, mumblecore small batch drinking vinegar
            messenger bag. Godard air plant gochujang messenger bag beard pok
            pok la croix portland YOLO migas church-key.
          </p>
        </div>
      </v-col>
    </v-row>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/home/PageLayout"

export default {
  name: "TutorialDetail",
  components: {
    PageLayout,
  },
  props: {
    tutorialId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      faqData: [
        {
          title: "Co je to Facebook Business Manager?",
          text:
            "I'm baby 8-bit hashtag tumeric meditation. Post-ironic skateboard gastropub polaroid taxidermy cloud bread. Freegan keffiyeh PBR&B marfa pop-up fashion axe. Vape hashtag mustache shaman shoreditch williamsburg stumptown raclette skateboard flexitarian squid raw denim kitsch locavore. You probably haven't heard of them 3 wolf moon direct trade, taiyaki bitters squid keytar shaman authentic. Actually direct trade pabst, tilde kombucha man bun hammock kickstarter portland hella pour-over cold-pressed live-edge.",
        },
        {
          title: "Proč potřebuji Facebook Business Manager?",
          text:
            "I'm baby 8-bit hashtag tumeric meditation. Post-ironic skateboard gastropub polaroid taxidermy cloud bread. Freegan keffiyeh PBR&B marfa pop-up fashion axe. Vape hashtag mustache shaman shoreditch williamsburg stumptown raclette skateboard flexitarian squid raw denim kitsch locavore. You probably haven't heard of them 3 wolf moon direct trade, taiyaki bitters squid keytar shaman authentic. Actually direct trade pabst, tilde kombucha man bun hammock kickstarter portland hella pour-over cold-pressed live-edge.",
        },
        {
          title: "Proč potřebuji reklamu?",
          text:
            "I'm baby 8-bit hashtag tumeric meditation. Post-ironic skateboard gastropub polaroid taxidermy cloud bread. Freegan keffiyeh PBR&B marfa pop-up fashion axe. Vape hashtag mustache shaman shoreditch williamsburg stumptown raclette skateboard flexitarian squid raw denim kitsch locavore. You probably haven't heard of them 3 wolf moon direct trade, taiyaki bitters squid keytar shaman authentic. Actually direct trade pabst, tilde kombucha man bun hammock kickstarter portland hella pour-over cold-pressed live-edge.",
        },
      ],
    }
  },
}
</script>

<style scope>
.tutorialDetail__img {
  border-radius: 6px;
}
</style>
